// utils/columnWidth.ts
export const calculateColumnWidth = (
    header: string,
    cellValues: string[],
    isSettings = false,
    fontSize = 14,
): number => {
    if (isSettings) return 45;

    const CHAR_WIDTH = fontSize * 0.5214;
    const PADDING = 20;
    const MIN_WIDTH = 80;
    const MAX_WIDTH = 500;

    const maxLength = Math.max(
        header.length,
        ...cellValues.map((v) => String(v).length),
    );

    const width = maxLength * CHAR_WIDTH + PADDING;

    return Math.min(Math.max(width, MIN_WIDTH), MAX_WIDTH);
};
export function sortData(data, originalData, columnIndex, direction, colors) {
    const [headers, ...rows] = data;

    let processedRows = rows;
    const hasActiveColors = colors && Object.values(colors).some(Boolean);

    if (hasActiveColors) {
        processedRows = processedRows.filter((row) => {
            const tickerName = row[1];
            if (!tickerName) return false;

            const originalRow = originalData.find(
                (item) => item.Name === tickerName,
            );
            let errorFlag = originalRow?.["Error Flag"];

            if (errorFlag !== undefined) {
                return colors[Number(errorFlag)] === true;
            }
            return false;
        });
    }

    if (columnIndex == null || columnIndex < 0) {
        return [...processedRows];
    }
    if (direction) {
        processedRows = processedRows.sort((a, b) => {
            const valueA = a[columnIndex];
            const valueB = b[columnIndex];

            const numA = Number(valueA);
            const numB = Number(valueB);

            let result;

            if (!isNaN(numA) && !isNaN(numB)) {
                result = numA - numB;
            } else {
                result = String(valueA).localeCompare(String(valueB));
            }

            return direction === "Up" ? result : -result;
        });
    }

    return [...processedRows];
}
export function debounce<T extends (...args: any[]) => any>(
    func: T,
    delay: number,
): ((...args: Parameters<T>) => void) & { cancel: () => void } {
    let timeoutId: NodeJS.Timeout | null = null;

    const debounced = (...args: Parameters<T>) => {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
            timeoutId = null;
        }, delay);
    };

    debounced.cancel = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };

    return debounced as any;
}
